
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_1kwmg_4",
  "wizard": "awsui_wizard_1xupv_1kwmg_14",
  "navigation": "awsui_navigation_1xupv_1kwmg_18",
  "refresh": "awsui_refresh_1xupv_1kwmg_18",
  "number": "awsui_number_1xupv_1kwmg_46",
  "circle": "awsui_circle_1xupv_1kwmg_62",
  "title": "awsui_title_1xupv_1kwmg_70",
  "active": "awsui_active_1xupv_1kwmg_97",
  "disabled": "awsui_disabled_1xupv_1kwmg_108",
  "enabled": "awsui_enabled_1xupv_1kwmg_118",
  "hidden": "awsui_hidden_1xupv_1kwmg_157",
  "form": "awsui_form_1xupv_1kwmg_162",
  "form-header": "awsui_form-header_1xupv_1kwmg_169",
  "form-header-refresh": "awsui_form-header-refresh_1xupv_1kwmg_173",
  "form-header-mobile": "awsui_form-header-mobile_1xupv_1kwmg_177",
  "form-header-content-refresh": "awsui_form-header-content-refresh_1xupv_1kwmg_181",
  "form-header-content-mobile": "awsui_form-header-content-mobile_1xupv_1kwmg_185",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_1kwmg_189",
  "collapsed-steps-extra-padding": "awsui_collapsed-steps-extra-padding_1xupv_1kwmg_194",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_1kwmg_197",
  "form-header-component": "awsui_form-header-component_1xupv_1kwmg_201",
  "navigation-link": "awsui_navigation-link_1xupv_1kwmg_202",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_1kwmg_203",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_1kwmg_204",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_1kwmg_208",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_1kwmg_213",
  "cancel-button": "awsui_cancel-button_1xupv_1kwmg_217",
  "previous-button": "awsui_previous-button_1xupv_1kwmg_218",
  "primary-button": "awsui_primary-button_1xupv_1kwmg_219",
  "skip-to-button": "awsui_skip-to-button_1xupv_1kwmg_220"
};
  